import { h, Component } from 'preact';
import IconHeader from '../icon-header';
import ariaIDProvider, { ScreenReaderText } from '../a11y';
import style from './style';
import cx from 'classnames';

@ariaIDProvider('locations-list')
export default class LocationsList extends Component { // eslint-disable-line react/prefer-stateless-function
	render({ header, headerIcon, a11yId, children, hideHeader, live, ...props }) {
		// If the header is visible, use `aria-lablledby` with the ID of the header. Otherwise, use aria-label or blank.
		const listLabel =	!hideHeader
			? { 'aria-labelledby': a11yId }
			: props['aria-label']
				? { 'aria-label': props['aria-label'] }
				: {};

		delete props['aria-label'];

		return (
			<div {...props} class={cx(style.container, props.class)}>
				<IconHeader id={a11yId} hidden={hideHeader} icon={headerIcon}>
					{header}
				</IconHeader>
				{live && <ScreenReaderText aria-live="polite">{live}</ScreenReaderText>}
				<ol class={style.list} {...listLabel}>
					{children}
				</ol>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ../node_modules/@cube/location-widget/src/components/locations-list/index.js